<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <div class="page_header_wrap" :class="{ filters_open: filtersList }">
        <div class="page_header">
          <div>
            <h2 ><a><img src="@/assets/images/pages/arrow.png"></a>Sent Emails</h2>
          </div>
          
          <div class="page_actions"> 
           
            <button  class="secondary_btn filters_btn" :class="{ active: filtersList }" @click="filtersList = !filtersList">
              <span class="material-icons"> filter_list</span>Filters
            </button>
          </div>
        </div>  
        <div class="filter_layer" @click="filtersList = !filtersList"></div>
        <div
      ref="filterCard"
      title="Filters"
      class="user-list-filters filters_list"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
         
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
        <label class="text-sm opacity-75">Search</label>
          <input
           v-model="filterData.title"
            class="search_field" 
            type="text"
            @keyup.enter="onEnter"
            placeholder="Search By Subject OR To Email"
          />
         <!--  @input="apply_filter(filterData)" -->
        </div>
            <template >  
            

             <div  class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">SDK</label>
         
          <multiselect
            v-model="filtersdkList"
            :options="sdkList"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select "
            label="name"
            track-by="name"
            :preselect-first="true"
            id="status"
            :multiple="true"
            
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Sdk(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Sdk Found</span>
          </multiselect>
          <!--<v-select :options="statusOptions" :clearable="false" 
            :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />-->
            </div>
            <div  class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Company</label>
          <multiselect
            v-model="filterData.companyIds"
            :options="companies"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select "
            label="name"
            track-by="name"
            :preselect-first="true"
            id="status"
            :multiple="true"
            @input="filterData.projectIds=[];getCustomerList()"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Company(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Companies Found</span>
          </multiselect>
          <!--<v-select :options="statusOptions" :clearable="false" 
            :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />-->
            </div>
            </template>


        
         <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  >
        
          <label class="text-sm opacity-75">Users</label>
         
          <multiselect
            v-model="filterData.customerIds"
            :options="customerList"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select"
            label="name"
            track-by="name"
            :preselect-first="true"
            id="Product"
            :multiple="true"
             @search-change="searchCustomerList"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} User(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Users Found</span>
          </multiselect>
           
        </div>
        
<div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Sent On</label>
          <date-range-picker :autoApply="autoApply" :maxDate="maxDate" 
          :ranges="false" v-model="selected_createdDateRange" placeholder="Select Range"></date-range-picker>
        </div>
        
        
        


       <!--
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
                <label class="text-sm opacity-75">Device Family</label>
                <multiselect
                  v-model="filterData.deviceFamDetails"
                  :options="device_family"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="status"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Device Family(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Device Families Found</span>
                </multiselect>
          
        </div>
        
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
                <label class="text-sm opacity-75">Versions</label>
                <multiselect
                  v-model="filterData.versionDetails"
                  :options="versions"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="Priority"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Case version(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No versions Found</span>
                </multiselect>
          
        </div>
-->
       
         
        <template v-if="activeUserInfo.roleId ==1" >
             <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10" ></div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10" ></div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  ></div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  ></div>
        </template>
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full marb10" ></div>
        <div class="vx-col md:w-3/4 sm:w-1/2 w-full marb10"  ></div>
     
        
       
         
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex align-end justify-end padt10 marb10 ">
           <button @click="clearFilters()" class="secondary_btn">
            Clear
          </button>
          <button class="primary_btn marl15" @click="apply_filter(filterData) ; filtersList = !filtersList">
            Apply
          </button>
        </div>
        
      </div>
    </div>
      </div>


      
     
    <vs-table class="table_list" :data="list" noDataText=""  > 
      <template slot="thead">
        <vs-th> To Email  </vs-th>
        <vs-th> Subject </vs-th>
        <vs-th>Sent On</vs-th>
       <vs-th> Action  </vs-th>

        
      </template>

      <template v-if="list && list.length > 0">
        <vs-tr v-for="(item, index) in list" :key="index"> 
          <vs-td class="ticket_id">  {{item.to}}  </vs-td>
          <vs-td> {{item.subject}}   </vs-td>
          <vs-td>  <span v-if="item.createdOn"><small>{{ item.createdOn | formatDateTime}}</small>  </span> </vs-td>
           <vs-td class="w-150">
              <button
                class="secondary_btn edit_btn marl0"
                @click="getDetails(item)" >
                View
              </button>
               
              
            </vs-td>
         
        </vs-tr>
      </template>
        <template v-else>
          <tr v-if="!loading">
            <td class="center-align" colspan="9">No Data Found!</td>
          </tr>
        </template>
    </vs-table>
   
      <div class="pagination_wrap" v-if="totalPages>1">
        <div class="pagination_content">
          <h6>Show Records </h6>
         <!--  <v-select
            @input="change_perPage()"
            v-model="perPage"
            :options="perPeges"
            label="Per Page"
            solo
          ></v-select> -->

          <multiselect
            :multiple="false" 
              @input="change_perPage()"
            placeholder="Page"
            
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            v-model="perPage" :options="perPeges" >
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} selected</span
                >
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                ></span>
              </template>
              
            </multiselect>
        </div>
        <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="page"
          @input="ticketcompanyUpdatedPriviously =false;getList()"
        />
      </div>

      <!------>
      <vs-popup
      class="holamundo mailpopup"
      :active.sync="showMailPopup"
      title="Mail Content"
    >
      <div class="createticket_form">
      
        <div v-html="hrmlData">
          
        </div>
        <div class="form_actions">
          <span></span>
          <button class="close_popup primary_btn" @click="showMailPopup =false">
            Close
          </button>
        </div>
      </div>
    </vs-popup>

     

  </div>
</template>

<script>
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import FileUpload from "vue-upload-component/src";
import Multiselect from 'vue-multiselect-inv';
import moment from "moment";

import _ from "lodash";
import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor );
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  components: { 
    //ClassicEditor,
    //CKEditor,
    vSelect,
    DateRangePicker,
    
    FileUpload,
    Multiselect
  },
   computed: {
     getAactiveCustomer() {
     
      if(_.has(this.$store.state.auth , 'ViewAsCustomer')){
         return this.$store.state.auth.ViewAsCustomer
      }else if(localStorage.getItem('ViewAsCustomer')){
        return  JSON.parse(localStorage.getItem('ViewAsCustomer'));
      }else{
        return null;
      }
     
    },
     
    
    activeUserInfo () {
      return this.$store.state.auth.user
    },
     validateProject() {
      return (
        !this.errors.any() &&
        this.projectName !== ""
      );
    },
    validateAssign() {
     // return this.assignedTo > 0
      return this.assignedTo != null
    },
  },
  data:() => ({
    
    sdkList:[],
    filtersdkList:[],
    emptyCompanytickets:[],
    ticketcompanyUpdatedPriviously:false,
    loading:false,
     companyUsersList:[],
    filtersList: false,        
    device_family:[],
    deviceFamDetails:null,

    ticket_priority:[],
    priorityDetails:null,

    ticket_type:[],
    ticketTypeDetails:null,

    versions:[],
    versionDetails: null,

    Areas:[],
    areaDetails:null,

    addTojiraPopup:false,
    transforToJiraItem:null,
    callFromSort:false,
    companies:[],
     customerList:[],
     searchCustomer:'',
     maxDate: new Date(),
    editor: ClassicEditor,
    editorConfig: {
        // The configuration of the editor.
        toolbar: [ 'bold', 'italic', '|', 'undo','redo' ,"indent" ,"Outdent" ,'NumberedList', 'BulletedList', ],
        
    },

    userdata:null,
    reportTo_obj:'',
    products: [],
    list: [],
    projects: [],
    companyProjects:[],
   // ticket: {"description":'',"title":'',"selectedProject":''},
   ticket: {
     selectedProject:null,
     title:'',
     selectedCompany:null,
   },
    sortKey: {createdOn:-1},
    page: 1,
    perPage: 25,
    totalPages: 0,
    sortKeys: {
      customId: 1,
      title:1,
      statusName: 1,
      createdOn: -1,
      createdByName: 1,
      projectName: 1,
      updatedOn: 1
    },
    documents:[],
    status_list: [],
    selected_createdDateRange :{
      startDate: null,
      endDate: null
    },
    perPeges: [25, 50, 75, 100],
    stats : {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6:0,
      7:0
    },
    autoApply: "",
    config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }          
        },
        charCounterCount: false,
        //toolbarButtons: ['undo', 'redo' , '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'outdent', 'indent', 'clearFormatting', 'insertTable', 'html'],
        toolbarButtons: ['undo', 'redo' , '|', 'bold', 'italic', 'underline'],
        //toolbarButtonsXS: ['undo', 'redo' , '-', 'bold', 'italic', 'underline']
      },
      model: 'Edit Your Content Here!',
    filterData: {
      title: "",
      statusIds: [],
      productIds: [],
      productIds: [],
      projectIds: [],
      customerIds: [],
      createdOnRange: [],
      companyIds:[],
      
      priorityDetails: [],
      typeDetails: [],
      areaDetails: [],
      deviceFamDetails: [],
      versionDetails: [],
      sharedToIdDetails:[],

    },

    userFilters: {
      title: "",
      statusIds: [],
      productIds: [],
      customerIds: [],
      projectIds: [],
      createdOnRange: [],
       companyIds:[],
    },
    projectName: '',
    popupCreateProject: false,
    assignedTo: null, //[],
    employeeList: [],
    popupAssignFlag: false,
    ticketId: "",

    reportinglist: [
      { label: 'Internal Project', value: 'internal' },
      { label: 'Customer Project', value: 'customer' } 
    ],
    textarea: '',
    popupcreateticket:false,
    dateRange:'',
    statusFilter: { label: 'All', value: 'all' },
    statusOptions: [
      { label: 'All', value: 'all' },
      { label: 'New', value: 'new' },
      { label: 'In Progress', value: 'inProgress' },
      { label: 'Rejected', value: 'rejected' },
      { label: 'Defered', value: 'defered' },
      { label: 'Closed', value: 'closed' }
    ],
    emailFilter: { label: 'All', value: 'all' },
    emailOptions: [
      { label: 'All', value: 'all' },
      { label: 'user@yopmail.com', value: 'user' },
      { label: 'admin@yopmail.com', value: 'admin' } 
    ],
      
    direction: 'ltr',
    format: 'mm/dd/yyyy',
    separator: ' - ',
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    weekLabel: 'W',
    customRangeLabel: 'Custom Range',
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    firstDay: 0,

    searchQuery: '',
    transforToItem:null,
    jiraResponse:null,
    submitedJira:false,
    isEdit:false,
    selectedItem:null,
    usersIdDetails:[],
    showMailPopup:false,
    hrmlData:'',


    ////////////
     
  }),
  methods:{
   
     toggleBodyClass(addRemoveClass, className) {
    const el = document.body;
   
    if (addRemoveClass === 'addClass') {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  },
    getDetails(item){
      this.hrmlData='';
      this.selectedItem = item;
     
      let postData ={"mailId":item['_id']}
      this.$store
        .dispatch("getMailContant", postData)
        .then((response) => {

          this.hrmlData = response['html'];
         this.showMailPopup =true;
        })
        .catch((err) => {
          this.$vs.notify({
                        text: 'Please Try again',
                        title: "Error",
                        position:'top-right',
                        color:"danger",
                        iconPack: 'feather',
                        icon:'icon-check',

                      });
          
        });

    },

    

    changedAssignTo(){
      if(this.activeUserInfo.roleId == 1){
        this.ticket = Object.assign(this.ticket ,{"assignedTo":[]});
       if( this.assignedTo != null && _.has(this.assignedTo ,"_id")){
            this.ticket['assignedTo'] =[ this.assignedTo['_id']] 
       }


      }
      

    },



    
    projectChanged(){
       this.usersIdDetails =[];
       this.ticket.sharedTo= [];
       
       this.getComapnyUsers();
    },
      getComapnyUsers(val='') {
    
      let postData =  {
		"matcher": {
			"searchString":val,
		//	"cntryId": 101,
		//	"stateId": 665,
		//	"cntryIds": [38], // Requied for "state" 
		//	"stateIds": [665], // Requied for "city"
		//	"roleIds": [5], // Required for "reporting_to"
    //		"getCompanyUsers": true, // Required for only user_list
		///	"timesheetApprovalUsers": true, // Required for only user_list
  		//"projectId": 2 // Required for only share_ticket_users
		},
		"page": 1,
		"perpage": 1000000,
		"category": "share_ticket_users", // share_project_users, share_ticket_users, ticket_priority, ticket_type, notes_tagged_to, notes_visible_to, notes_status, notes_category, timesheet_work_type, timesheet_status,document_status, folder_status, request_status, request_priority, client_list, task_status, user_list, reporting_to, user_status,user_role,company_status,client_status,industry,company_type,designation,country,state,department 
	}
      // alert(this.activeUserInfo.companyId);

     if(_.has(this.ticket ,'selectedProject' ) && this.ticket['selectedProject']){
       postData['matcher']['projectId'] = this.ticket['selectedProject']['_id'];

     }

     if(this.ticket.companyId){
       postData['matcher']['companyIds'] =[this.ticket.companyId];
     }
      
        
     
      this.companyUsersList = [];
      this.$store
        .dispatch("getMasterData", postData)
        .then((response) => {
          let customers = response.list;
          _.forEach(customers ,(item)=>{
              if(_.has(item ,"name") && _.has(item ,"email") ){
                item['name'] = item['name'] +" ( "+item['email']+" )"
              }

             if(this.isEdit){
                if(_.has(this.selectedItem ,"owners") && this.selectedItem.length>0 ){
                    if( _.includes(this.selectedItem['owners'] , item['_id']) <=-1){
                        this.companyUsersList.push(item);
                    }
                }else{
                  this.companyUsersList.push(item);

                }

              }else{
                  this.companyUsersList.push(item);
              }
             

            
           

          });
         
          //this.totalpages = Math.ceil(response.totalCount / this.perPage);
        })
        .catch((err) => {
          console.log(err);
         // this.loaded = true;
        });
    },
    
   
   

    checkProperty(obj ,key='' ,subKye=''){
      
      if(_.has(obj , key)){
         //alert(key+" ---"+subKye)
        if(obj[key]){
          if(subKye==''){
            return obj[key];
          }else{

            if(_.has(obj[key] , subKye)){
              if(obj[key][subKye]){
                 return obj[key][subKye];
              }else{
                 return false;
              }

            }else{
              return false;
            }
          }
          
        }else{
          return false;
        }
     

      }else{
        return false;
      }

    }, 
    getAreas(){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: 'area'
      }
      this.$store.dispatch("getAreas" ,postData).then((response) => {
      this.Areas = _.filter(response, (obj)=> {
        return obj._id != 2;
      });
    });

    },
    changedArea(item){
      this.ticket.areaId ='';
      if(item !=null){
        this.ticket.areaId =item._id;
      }
      
    },
    changedDevice(item){
      this.ticket.deviceFamId  ='';
      if(item !=null){
        this.ticket.deviceFamId =item._id;
      }
      
    },

    changedType(item){
      this.ticket.typeId  ='';
      if(item !=null){
        this.ticket.typeId =item._id;
      }
      
    },

    changedPriority(item){
      this.ticket.priorityId  ='';
      if(item !=null){
        this.ticket.priorityId =item._id;
      }
      
    },

    getMasterData(category ="device_family"){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: category
      }
      this.$store.dispatch("getDeviceFamily" ,postData).then((response) => {
      this[category] = response;
     
    });

    },
    changedVersion(item){
      this.ticket.version ='';
      if(item !=null){
        this.ticket.version =item._id;
      }
     
    },
    getVersions(){
      let postData = {
      "filters":{ "title": ""},		
        "page": 1,
        "perpage": 1000000000
      }
      this.$store
        .dispatch("getSdkVersionsList", postData)
        .then((response) => {
          this.versions = response.list;
          
         
        })
        .catch((err) => {
          console.log(err);
          
          
        });
    },
    

    getDescription(sdk){
      let hrml  = sdk.description;
      let str = hrml.replace(/<[^>]*>/g, '');
      return str.substring(0, 15);
    },

    // @search-change="searchCustomerList"
    searchCustomerList(val=''){
      this.searchCustomer = val;
      this.getCustomerList();
    },
    getCustomerList() {
      let postData = {"filters":{"title":this.searchCustomer,"roleIds":[2],"statusIds":[],"createdOnRange":[] ,"companyIds":[]},"sorting":{"path":"createdOn","order":1},"page":1,"perpage":25};
     
     
     if(this.filterData.companyIds && this.filterData.companyIds.length>0 && this.activeUserInfo.roleId != 2){
         _.forEach(this.filterData.companyIds  ,(obj)=>{
             postData['filters']['companyIds'].push(obj['_id']);
         });
     }


     if(this.activeUserInfo.roleId ==2 && this.activeUserInfo.companyId){
         postData['filters']['companyIds'] =[];
         postData['filters']['companyIds'].push(this.activeUserInfo.companyId);
      

     }

     this.getCompanyProjects(false);
     
     //filterData.customerIds
      this.customerList = [];
      this.$store
        .dispatch("auth/get_users_list", postData)
        .then((response) => {
          //this.customerList = response.list;
          let dt  = response.list;
          if(dt.length>0){
            _.forEach(dt ,(obj)=>{
              let cus = obj;
              if(_.has(obj ,"companyDetails")){
                cus['name'] =  cus['name']+" ("+obj['companyDetails']['name']+")"
              }
              this.customerList.push(cus);



            });

          }
          //this.totalpages = Math.ceil(response.totalCount / this.perPage);
        })
        .catch((err) => {
          console.log(err);
          this.loaded = true;
        });
    },
    
    addProject (newTag) {
      this.reportinglist.push( 
        { 'label':newTag, 'value':newTag} 
      )
    },
     change_perPage() {
      this.page = 1;
      this.getList();
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
     setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    openCreatePop() {
      this.assignedTo = null;
      this.ticket.selectedProject =null;
      this.isEdit =false;
      setTimeout(()=>{ 
        this.errors.clear();
      },10);
      this.init();
      this.popupcreateticket = true;
     
     // this.updateUserKey();
    },
    
    openProjectPop() {
      this.projectName = ""
      this.errors.clear();
      this.popupCreateProject = true;
    },
     init() {
        this.filtersList =false;
        this.usersIdDetails = [];
      this.ticket = {
        selectedCompany:null,

        sharedTo:[],
        description: "",
        title: "",
        selectedProject:null,
        productId: "",
        documents: [],
        projectId: "",
        today: moment().format("YYYY-MM-DD"),
        deviceFamId:'',
        areaId:'',
        version:'',
        priorityId:"",
        typeId:''
      };

      if(_.has(this.userdata , 'companyId') && this.userdata['companyId'] ){
     this.ticket['companyId'] =this.userdata['companyId'];
     this.ticket = Object.assign(this.ticket ,{"companyId":this.userdata['companyId']}) 

   }

    if(this.ticket['companyId'] && this.companies){
      this.ticket.selectedCompany = _.find(this.companies , {"_id":this.ticket['companyId']})

    }

    
    this.deviceFamDetails = null;
    this.priorityDetails = null;
    this.ticketTypeDetails = null;

    this.versionDetails =  null;
    this.areaDetails = null;
    },
    getList() {
      let postData = {
      //  filters: {
      //     title: this.userFilters.title,
      //     projectIds: this.userFilters.projectIds, //[4, 5],
      //     productIds: this.userFilters.productIds, //[4, 5],
      //     statusIds: this.userFilters.statusIds,
      //     customerIds:this.userFilters.customerIds,
      //     companyIds:this.userFilters.companyIds,
      //     createdOnRange:[],
      //   },
           filters:{
             "types": ["SDK_PUBLISH"],
             "title": this.filterData.title,
           
            "userIds": [],
            "companyIds": [] ,
            "createdOnRange":[],
   
            sdkIds:[]

           },
        sorting: this.sortKey, //{"path": "name","order": -1	},
        page: this.page,
        perpage: this.perPage,
      };
       
       
       if(this.filterData.customerIds.length>0){
        for( let i=0; i<this.filterData.customerIds.length;i++){
          postData.filters.userIds.push(this.filterData.customerIds[i]['_id'] )
        }
      }
       if(this.filterData.companyIds.length>0){
        for( let i=0; i<this.filterData.companyIds.length;i++){
          postData.filters.companyIds.push(this.filterData.companyIds[i]['_id'] )
        }
      }
      
      if(this.filtersdkList.length>0){
        for( let i=0; i<this.filtersdkList.length;i++){
          postData.filters.sdkIds.push(this.filtersdkList[i]['_id'] )
        }
      }   

      if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      }

     

     
     
      if(!this.callFromSort){
         this.list = [];
         this.$vs.loading()
      }
      this.callFromSort =false;
     this.loading =true;
    
      
      this.$store
        .dispatch("getSentEmailsList", postData)
        .then((response) => {
          this.list = response.list;
         
          this.totalPages = Math.ceil(response.totalCount / this.perPage);
           
           this.loading =false;
          this.$vs.loading.close();

        })
        .catch((err) => {
          this.loading =false;
            this.$vs.loading.close();
          console.log(err);
        });
    },
   
    sortMe(sort_key = "") {
      
      this.sortKey = { path: "createdOn", order: -1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};

        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.callFromSort =true;
        //alert();
        this.getList();

      }
    },
    
   
   
    apply_filter(data) {
      this.filterData = data;
      this.page = 1;
      // this.userFilters = {
      //   title: data.title,
      //   statusIds: [],
      //   productIds: [],
      //   customerIds: [],
      //   projectIds: [],
      //   createdOnRange: [],
      //   companyIds:[],
      // };
      // if (this.filterData["productIds"].length > 0) {
      //   for (let i = 0; i < this.filterData["productIds"].length; i++) {
      //     this.userFilters["productIds"].push(
      //       this.filterData["productIds"][i]["_id"]
      //     );
      //   }
      // }

      // if (this.filterData["projectIds"].length > 0) {
      //   for (let i = 0; i < this.filterData["projectIds"].length; i++) {
      //     this.userFilters["projectIds"].push(
      //       this.filterData["projectIds"][i]["_id"]
      //     );
      //   }
      // }

      
      //  //customerList
      //   if (this.filterData["customerList"].length > 0) {
         
      //      this.userFilters["customerIds"] = [];
      //     for (let i = 0; i < this.filterData["customerList"].length; i++) {
      //       this.userFilters["customerIds"].push(this.filterData["customerList"][i]["_id"]);
      //     }
      //   }

      //   //companyIds
      //    if (this.filterData["companyIds"].length > 0) {
         
      //      this.userFilters["companyIds"] = [];
      //     for (let i = 0; i < this.filterData["companyIds"].length; i++) {
      //       this.userFilters["companyIds"].push(this.filterData["companyIds"][i]["_id"]);
      //     }
      //   }
      
    
      this.getList();
    },
    onAddProject() {
      const payload = {
        name: this.projectName,
      };
      payload.category = 'project'
      this.$vs.loading();
      this.$store
        .dispatch("projectCreate", payload)
        .then((res) => {
          this.popupCreateProject = false;
          this.projectName = "";
          this.getProjectList();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        })
        .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: error.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
    },
    getCompanyProjects(callfromNewTicke =false){
      this.companyProjects =[];
      let postData = {"matcher":{ "companyIds":[],"searchString":"","sharedToIds":[]},"page":1,"perpage":50000,"category":"project"};
      
       if(this.filterData.companyIds && this.filterData.companyIds.length>0 && !callfromNewTicke ){
         _.forEach(this.filterData.companyIds  ,(obj)=>{
             postData['matcher']['companyIds'].push(obj['_id']);
         });
        }else{
          postData['matcher']['companyIds'] = [];
          if(this.ticket.selectedCompany && callfromNewTicke ){

             postData['matcher']['companyIds'].push(this.ticket.selectedCompany['_id']);
             this.ticket['companyId']  =this.ticket.selectedCompany['_id'];
            

          }
        }
        
        //ticket.selectedCompany
      this.$store.dispatch("getMasterData" , postData).then((response) => {
        if(callfromNewTicke){
          this.projects = response['list'];
        }else{
          this.companyProjects = response['list'];
        }
         
         //alert(JSON.stringify(postData))

      })

    },
    getProjectList() {
        this.$store.dispatch("getProjects").then((response) => {
          let data = response;
           if (
      this.$route.params.projectId != undefined &&
      this.$route.params.projectId != null
    ) {

      let projedObj = null;
      _.forEach(data , (item)=>{
        if(item['_id'] ==this.$route.params.projectId ){
          projedObj = item;

        }

      });
         
      if(projedObj){
        this.filterData.projectIds.push(projedObj);

      }
      this.getList();
      
    }
        this.projects = data;
      });
    },
    openAssignPopup(item) {
      this.ticketId = item._id;
      this.assignedTo = null;//[]
        if (item.assignEmpDetails && item.assignEmpDetails.length > 0) {
            //this.assignedTo = item.assignEmpDetails;

          item.assignEmpDetails.forEach(obj => {
               if(obj ,"roleName"){
                   obj.name = obj.name + '('+obj.roleName +')'
               }
             
            })

            this.assignedTo = item.assignEmpDetails[0];
        } else {
          this.assignedTo = null //[]
        } 
      this.popupAssignFlag = true;
    },
    onAssignEmployee() {
      // this.assignedTo = this.assignedTo.map(item => item._id);
      let selectedAssignedTo =[] 
      if( this.assignedTo != null && _.has(this.assignedTo ,"_id")){
       selectedAssignedTo =[ this.assignedTo['_id']] 
      }

      
     
      
      const payload = {
        ticketId: this.ticketId,
        assignedTo: selectedAssignedTo //this.assignedTo
      };
     this.$vs.loading();
    this.$store
        .dispatch("assignEmployees", payload)
        .then((res) => {
          this.popupAssignFlag = false;
          this.getList()
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
      
     },
     getDashboardStats() {
      let postData = {};
      this.$store
        .dispatch("getTicketStats", postData)
        .then((response) => {
          _.forEach(response ,(object ,index) => {
            this.stats[object.statusId] = object.count;
         })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearFilters() {
      this.filtersdkList =[];
      this.filtersList =false;
       this.filterData = {
        title: "",
        statusIds: [],
        productIds: [],
        productIds: [],
        projectIds: [],
        createdOnRange: [],
        companyIds:[],
        customerIds: [],

      priorityDetails: [],
      typeDetails: [],
      areaDetails: [],
      deviceFamDetails: [],
      versionDetails: [],
      sharedToIdDetails:[],
      }
      this.selected_createdDateRange  = {
        startDate: null,
        endDate: null
      },
      this.getList();
    },
   transferToJiraCheck(item) {
      if(_.has(item , 'jiraId') && item['jiraId'] && _.has(item , 'jiraKey') && item['jiraKey'] ){
        return true;
      } else {
        return false;
      }
    },
    onEnter() {
      this.filtersList =false;
      this.getList();
    },
     getSdkList(text=''){
      
       const postData = {
        filters: {
          "title":text ,
          "sdkIds": [],
        	"userIds": [],
         	"companyIds": [],
		      "createdOnRange": []
        },
        sorting:  { path: "createdOn", order: -1 }, //{"path": "name","order": -1	},
        
        page:1,
        perpage:10000000000,
      };
      this.$store
        .dispatch("getSdkList", postData)
        .then((response) => {
          let sdkList = response.list;
          this.sdkList = sdkList.map((item)=>{ 

            return { name:item.title+'('+ item.version +')',"_id":item['_id'] } 
            
            });
           
          
           this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);

        });

    },
  },
  mounted() {

    this.filtersdkList =[];

     if(
        ( _.has(this.$route ,"query" ))
        && ( _.has(this.$route.query ,"filter" ) &&  this.$route.query.filter != undefined &&   this.$route.query.filter != null)
       

        ) {
          this.filtersdkList.push({"_id":this.$route.query.filter});

        }
   
    this.userdata = this.$store.state.auth.user;
   // this.ticket['companyId']  =this.ticket.selectedCompany['_id'];
    //alert(JSON.stringify(this.userdata));
   if(_.has(this.userdata , 'companyId') && this.userdata['companyId'] ){
     this.ticket['companyId'] =this.userdata['companyId'];
     this.ticket = Object.assign(this.ticket ,{"companyId":this.userdata['companyId']}) 

   }

   this.getSdkList();
    this.getComapnyUsers();
    this.sortKey = { path: "createdOn", order: -1 };
    this.$store.dispatch("getProducts").then((response) => {
      this.products = response;
    });
    this.$store.dispatch("getTicketStatus").then((response) => {
      this.status_list = response;
    });
    this.$store.dispatch("getEmployeeList").then((response) => {
     
      this.employeeList = response;
      this.employeeList.forEach(item => {
        item.name = item.name + '('+item.roleName +')'
      })
      //this.employeeList = this.employeeList.map(item => item.name.concat(item.roleName))
    });
    this.$store.dispatch("getCompanies").then((response) => {
          this.companies = response;
     //alert(JSON.stringify(this.companies));
          if(this.ticket['companyId']){
            this.ticket.selectedCompany = _.find(this.companies , {"_id":this.ticket['companyId']})

          }
        });

    this.getProjectList();
    this.getCompanyProjects();
    this.getCustomerList();
    this.sortKeys = {
      customId: 1,
      statusName: 1,
      createdOn: -1,
      createdByName: 1,
      projectName: 1,
      updatedOn: 1
    };

    this.sortKey=  {createdOn:-1},
    this.getList();
    this.getDashboardStats();
    this.getVersions(); 
    
    this.getMasterData('device_family');
    this.getMasterData('ticket_priority');
    this.getMasterData('ticket_type');
    this.getAreas();
  },
  watch:{
     //this.toggleBodyClass('addClass",'scroll-hidden')
     showMailPopup:(val)=>{

     },
    showMailPopup:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('scroll-hidden');
        } else {
            el.classList.remove('scroll-hidden');
        }
        
    },
    popupCreateProject:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
    popupcreateticket:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
   
 
  }


}
</script>
<style  lang="scss">

.con-expand-users {
  .con-btns-user {
        display: flex;
        padding: 10px;
        padding-bottom: 0px;
        align-items: center;
        justify-content: space-between;
        .con-userx {
        display: flex;
        align-items: center;
        justify-content :flex-start;
            .list-icon {
                i{ font-size: .9rem !important;}
            }
        }
    }
}
.not-data-table  {display:none;}
 
.multiselect .multiselect__content-wrapper ul li .multiselect__option:after {    display: inline-block !important;
    content: attr(data-select);
    background: #41b883;    position: absolute;
    right: 5px;padding: 0 10px;
    color: #fff;}
</style>